<ng-container *ngIf="data?.success; else noData">
	<ng-container>
		<ac-chart [highChartsAttributes]="highChartAttributes"></ac-chart>
	</ng-container>
</ng-container>
<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
